var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotLoggedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "lock",
    className: "icon_not_logged_in_svg__svg-inline--fa icon_not_logged_in_svg__fa-lock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M384 223.1l-16 .9v-80C368 64.59 303.41 0 224 0S80 64.59 80 144v80l-16-.9c-35.35 0-64 28.65-64 64v160c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64v-160c0-34.4-28.7-64-64-64zM144 144c0-44.12 35.9-80 80-80s80 35.88 80 80v80H144v-80z"
  })));
}
export default SvgIconNotLoggedIn;